import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatbotWidget from "@/components/ChatbotWidget";
import WelcomePopup from "@/components/WelcomePopup";
import StickyMobileCta from "@/components/StickyMobileCta";
import SocialProofPopup from "@/components/SocialProofPopup";

export default function Layout() {
  const { pathname } = useLocation();
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-white text-black">
      <Navbar />
      <main className="flex-1 pb-14 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <ChatbotWidget />
      <StickyMobileCta />
      <SocialProofPopup />
      <WelcomePopup />
    </div>
  );
}
